import api from './api';
import { uploadImageToCloudinary } from './cloudinaryService';

export const restaurantService = {
  getRestaurantStats: async () => {
    try {
      const response = await api.get('/api/business/restaurant/stats');
      return {
        success: true,
        data: {
          rating: {
            averageRating: response.data.data.rating?.averageRating || 0,
            totalRatings: response.data.data.rating?.totalRatings || 0,
            reviews: response.data.data.rating?.reviews || []
          },
          followers: response.data.data.followers || [],
          followersCount: response.data.data.followers?.length || 0,
          followersGrowth: response.data.data.followersGrowth || 0,
          rank: response.data.data.rank || {
            score: 0,
            position: 0,
            totalInCity: 0,
            metrics: {
              rating: 0,
              followers: 0,
              activity: 0
            }
          },
          city: response.data.data.address?.city || ''
        }
      };
    } catch (error) {
      console.error('Restaurant stats error:', error);
      throw error;
    }
  },

  getRestaurantDetails: async () => {
    try {
      const response = await api.get('/api/business/restaurant/details');
      return {
        success: true,
        data: {
          ...response.data.data,
          businessType: response.data.data.businessType || 'RESTAURANT',
          followers: response.data.data.followers || [],
          rating: response.data.data.rating || {
            averageRating: 0,
            totalRatings: 0
          }
        }
      };
    } catch (error) {
      console.error('Restaurant details error:', error);
      throw error;
    }
  },

  updateRestaurantDetails: async (data) => {
    try {
      const response = await api.put('/api/business/restaurant/details', data);
      return response.data;
    } catch (error) {
      console.error('Restaurant update error:', error);
      throw error;
    }
  },

  uploadProfileImage: async (formData) => {
    try {
      const file = formData.get('image');
      if (file && typeof file !== 'string' && file.size != null) {
        try {
          const secureUrl = await uploadImageToCloudinary(file, 'logo');
          const response = await api.post('/api/business/restaurant/logo-url', {
            imageUrl: secureUrl
          });
          return response.data;
        } catch (cloudErr) {
          console.warn('Cloudinary logo yüklemesi başarısız, sunucu upload deneniyor:', cloudErr?.message);
        }
      }
      const response = await api.post('/api/business/restaurant/upload-logo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Profile image upload error:', error);
      throw error;
    }
  }
};

export default restaurantService; 